var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26627)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8164 1V155.61",
    stroke: "url(#paint1_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.418 1V155.61",
    stroke: "url(#paint2_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.764 1V155.61",
    stroke: "url(#paint3_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.107 1V155.61",
    stroke: "url(#paint4_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.709 1V155.61",
    stroke: "url(#paint5_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.055 1V155.61",
    stroke: "url(#paint6_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362.654 1V155.61",
    stroke: "url(#paint7_linear_5390_26627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M413.998 1V155.61",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M411.023 46.695C410.681 46.695 411.021 47.5561 410.697 47.5679C375.847 47.9424 394.346 67.4915 366.108 67.4915C337.871 67.4915 343.305 44.5521 314.801 44.5521C286.298 44.5521 299.599 80.8455 263.495 80.8455C227.39 80.8455 246.392 8.25867 212.188 8.25867C177.983 8.25867 195.086 52.8618 160.881 52.8618C126.677 52.8618 141.879 21.0509 109.574 21.0509C77.2702 21.0509 86.7714 72.7582 60.1679 72.7582C33.5644 72.7582 35.3507 49.1868 10.4954 47.1503C9.37426 47.0567 8.1961 47.0099 6.96094 47.0099",
    stroke: "url(#paint8_linear_5390_26627)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.023 106.687C410.373 106.687 403.885 106.5 409.713 106.977C390.329 106.394 390.798 95.6778 364.857 95.6778C338.915 95.6778 341.917 63.3636 313.242 63.3636C284.567 63.3636 282.655 106.756 261.627 106.756C240.599 106.756 234.864 82.2582 210.012 82.2582C185.161 82.2582 187.073 103.983 158.398 103.983C129.723 103.983 135.458 60.5212 106.783 60.5212C78.1083 60.5212 78.1083 91.5307 55.1685 91.5307C32.2286 91.5307 33.31 77.5287 8.34377 76.8531C7.73204 76.8298 8.35504 77.071 7.70508 77.071",
    stroke: "url(#paint9_linear_5390_26627)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M403.701 55.4401C407.212 55.4401 410.057 52.5153 410.057 48.9073C410.057 45.2994 407.212 42.3745 403.701 42.3745C400.191 42.3745 397.346 45.2994 397.346 48.9073C397.346 52.5153 400.191 55.4401 403.701 55.4401Z",
    fill: "url(#paint10_linear_5390_26627)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M403.701 113.51C407.212 113.51 410.057 110.585 410.057 106.977C410.057 103.369 407.212 100.444 403.701 100.444C400.191 100.444 397.346 103.369 397.346 106.977C397.346 110.585 400.191 113.51 403.701 113.51Z",
    fill: "url(#paint11_linear_5390_26627)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8283 53.9884C15.3385 53.9884 18.184 51.0635 18.184 47.4555C18.184 43.8476 15.3385 40.9227 11.8283 40.9227C8.31819 40.9227 5.47266 43.8476 5.47266 47.4555C5.47266 51.0635 8.31819 53.9884 11.8283 53.9884Z",
    fill: "url(#paint12_linear_5390_26627)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8283 83.7491C15.3385 83.7491 18.184 80.8243 18.184 77.2163C18.184 73.6083 15.3385 70.6835 11.8283 70.6835C8.31819 70.6835 5.47266 73.6083 5.47266 77.2163C5.47266 80.8243 8.31819 83.7491 11.8283 83.7491Z",
    fill: "url(#paint13_linear_5390_26627)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26627",
    x: 0,
    y: 1,
    width: 414.057,
    height: 196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26627",
    x1: 4,
    y1: 189,
    x2: 421.904,
    y2: 43.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5390_26627",
    x1: 57.3164,
    y1: 1,
    x2: 57.3164,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5390_26627",
    x1: 107.918,
    y1: 1,
    x2: 107.918,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5390_26627",
    x1: 159.264,
    y1: 1,
    x2: 159.264,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5390_26627",
    x1: 210.607,
    y1: 1,
    x2: 210.607,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5390_26627",
    x1: 261.209,
    y1: 1,
    x2: 261.209,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5390_26627",
    x1: 312.555,
    y1: 1,
    x2: 312.555,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5390_26627",
    x1: 363.154,
    y1: 1,
    x2: 363.154,
    y2: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5390_26627",
    x1: 208.992,
    y1: 8.25867,
    x2: 208.992,
    y2: 80.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5390_26627",
    x1: 209.364,
    y1: 60.5212,
    x2: 209.364,
    y2: 106.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5390_26627",
    x1: 410.057,
    y1: 55.4403,
    x2: 397.346,
    y2: 55.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5390_26627",
    x1: 410.057,
    y1: 113.51,
    x2: 397.346,
    y2: 113.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5390_26627",
    x1: 18.184,
    y1: 53.9885,
    x2: 5.47266,
    y2: 53.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5390_26627",
    x1: 18.184,
    y1: 83.7492,
    x2: 5.47266,
    y2: 83.7492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.ce7c953d1d0c8014f8242117a51c9294.svg";
export { ForwardRef as ReactComponent };